import type { Panel } from "."

export const centerPanelWithinPadding = ({
  panel,
  gap,
}: {
  panel: Panel
  gap: number
}): { x: number; y: number; w: number; h: number } => {
  const currentPosition = {
    x: panel.xSnap ?? panel.x,
    y: panel.ySnap ?? panel.y,
  }

  return {
    x:
      currentPosition.x +
      (gap * Math.sqrt(2) * Math.cos(((panel.r + 45) * Math.PI) / 180)) / 2,
    y:
      currentPosition.y +
      (gap * Math.sqrt(2) * Math.sin(((panel.r + 45) * Math.PI) / 180)) / 2,

    w: panel.w - gap,
    h: panel.h - gap,
  }
}
